import { getBrowserWidthBucket } from 'owa-layout';
import { CalendarLayoutBrowserConstants } from '../constants';

export function shouldShowAgendaPaneAsOverlay() {
    const availableWidthBucket = getBrowserWidthBucket();
    return availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowAgendaPaneAsOverlay;
}
